import React from 'react'

export default class MetricComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: '--',
      isLoading: true,
    }
  }

  componentDidMount(){
    this.fetchData()
  }

  fetchData(){
    const { organization_name, metric } = this.props
    let data = {
      number_member_sober_livings: 2,
      zip_code_distribution: [{name: '50%', value: 90288}, {name: '50%', value: 91188}],
      number_of_residents_total: 18,
      number_of_residents_per_sober_living_1: 10,
      number_of_residents_per_sober_living_2: 8,
      number_of_vacant_beds_per_sober_living_1: 0,
      number_of_vacant_beds_per_sober_living_2: 0,
      membership_form: 2,
      resident_move_in: 1,
    }
    this.setState((prevState, props)=>{
      return {
        isLoading: false,
        data: data[metric.endpoint]
      }
    })
  }
}